import React from 'react';
import { useAuth } from '../../auth';
import { VCredit } from '../keno/VCredit';
import { useVIPRewards } from './useVIPRewards';
import './quickRewards.css';

const RakebackControl = ({ amount, loading = false, busy = false, disabled = false, error, retry = false, onClaim }) => <div className="quick-rakeback-wrap" data-testid="quick-rakeback">
    <div className="quick-rakeback-control"><div><span className="quick-rakeback-label" data-testid="quick-rakeback-label">Rakeback available</span>
      {loading ? <span data-testid="quick-rakeback-loading">Loading…</span> : <VCredit minor={amount} testid="quick-rakeback-amount" />}</div>
      <button type="button" className="quick-rakeback-claim" data-testid="quick-rakeback-claim" disabled={busy || disabled}
        onClick={onClaim}>{busy ? 'Claiming…' : retry ? 'Retry' : 'Claim'}</button>
    </div>
    {error && <p role="alert" className="quick-rakeback-error" data-testid="quick-rakeback-error">{error}</p>}
  </div>;

const PlayerRakeback = ({ owner }) => {
  const reward = useVIPRewards(owner);
  return <RakebackControl amount={reward.data?.available_minor} loading={!reward.data} busy={reward.busy}
    disabled={!reward.data?.can_claim && !reward.retryPending && !reward.error}
    error={reward.error || reward.data?.blocked_reason} retry={!!reward.error}
    onClaim={reward.error && !reward.retryPending ? reward.reload : reward.claim} />;
};

export const QuickRakeback = ({ onAuth }) => {
  const { user } = useAuth();
  return user ? <PlayerRakeback key={user.id} owner={user.id} /> : <RakebackControl amount={0} onClaim={() => onAuth?.('login')} />;
};